export const createOption = (className, text = ``) => {
  const option = document.createElement(`option`);
  option.className = className;
  option.textContent = text;

  return option;
};
